import React, { Component, PropTypes } from 'react';
import { inject, observer } from "mobx-react";
import { Tree, TreeNode } from "react-organizational-chart";
import Spinner from "../Spinner";

@inject("locationStore", 'locationTypeStore')
@observer
class LocationTree extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  state = {
    root: null,
    parent_id: null
  };

  componentWillMount() {
    const { locationStore, locationTypeStore } = this.props;
    if (!locationStore.items.length && !locationStore.isLoading) locationStore.fetchItems();
    if (!locationTypeStore.items.length && !locationTypeStore.isLoading) locationTypeStore.fetchItems();
  }

  handleDelete = (id) => {
    /*global event, fdescribe*/
    /*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/
    if (confirm("Delete Location?")) {
      const { notify } = this.context;
      this.props.locationStore.removeItems(id)
        .then(() => notify.success({ message: 'Deleted' }))
        .catch(err => {
          console.log(err);
          notify.error({ message: err.toString() });
        });
    }
  }

  handleAdd = (id) => {
    this.setState({ parent_id: id })
    const { router } = this.context;
    router.push('/configurations/location/location-tree/add');
  }

  handleEdit = (id) => {
    const { router } = this.context;
    router.push(`/configurations/location/location-tree/${id}`);
  }

  _renderNodeLabel = (node, showDelete = false) => (
    <div className="location-tree-node">
      {node.name}
      <br />
      <i className="fa fa-plus" onClick={() => this.handleAdd(node.id)}></i>
      <i className="fa fa-pencil" onClick={() => this.handleEdit(node.id)}></i>
      {showDelete && <i className="fa fa-trash" onClick={() => this.handleDelete(node.id)}></i>}
    </div>
  )

  _renderChildNodes = (nodes) => {
    const { locationStore } = this.props;
    return nodes.map(node => {
      const childNodes = locationStore.items.filter((item) => +item.parent_id === +node.id)
      return (
        <TreeNode key={node.id} label={this._renderNodeLabel(node, !childNodes.length)}>
          {this._renderChildNodes(childNodes)}
        </TreeNode>
      );
    })
  }

  render() {
    const { locationStore, locationTypeStore, children } = this.props;

    if (locationStore.isLoading || locationTypeStore.isLoading) return <Spinner />;
    if (!locationStore.items.length) return <div></div>;

    const rootNodes = locationStore.items.filter(item => !item.parent_id)
    const selectedRoot = this.state.root ? locationStore.items.find(item => item.id === this.state.root) : rootNodes[0];

    return (
      <div>
        <div className="location-roots-tab">
          {rootNodes.map((root) => (
            <button key={root.name} className={`${selectedRoot.id === root.id ? 'location-root location-root-active' : 'location-root'}`} onClick={() => this.setState({ root: root.id })}>
              {root.name}
            </button>
          ))}
        </div>
        <div className="location-tree-div">
          <Tree
            lineWidth={"2px"}
            lineColor={"#3c8dbc"}
            lineBorderRadius={"10px"}
            label={this._renderNodeLabel(selectedRoot)}
          >
            {this._renderChildNodes(locationStore.items.filter((item) => +item.parent_id === +selectedRoot.id))}
          </Tree>
        </div>

        {this.props.children ? React.cloneElement(children, { slug: 'configurations/location/location-tree', parent_id: this.state.parent_id }) : ''}
      </div>
    );
  }
}

export default LocationTree;


// WEBPACK FOOTER //
// ./src/components/Location/LocationTree.js